"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Checkbox = void 0;

var _react = _interopRequireDefault(require("react"));

var _field = require("../field");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var CheckboxComponent = function CheckboxComponent(_ref) {
  var getValue = _ref.getValue,
      getErrors = _ref.getErrors,
      setValue = _ref.setValue,
      setTouched = _ref.setTouched,
      _onBlur = _ref.onBlur,
      _onChange = _ref.onChange,
      onValue = _ref.onValue,
      offValue = _ref.offValue,
      props = _objectWithoutProperties(_ref, ["getValue", "getErrors", "setValue", "setTouched", "onBlur", "onChange", "onValue", "offValue"]);

  return /*#__PURE__*/_react["default"].createElement("input", _extends({}, props, {
    checked: onValue === getValue(),
    type: "checkbox",
    onChange: function onChange(event) {
      event.persist();
      setValue(event.target.checked ? onValue : offValue, function () {
        if (_onChange) {
          _onChange(event);
        }
      });
    },
    onBlur: function onBlur(event) {
      event.persist();
      setTouched(function () {
        if (_onBlur) {
          _onBlur(event);
        }
      });
    }
  }));
};

CheckboxComponent.displayName = 'Checkbox';
var Checkbox = (0, _field.Field)(CheckboxComponent, {
  hideError: true
});
exports.Checkbox = Checkbox;